<script lang="ts">
  import CmsImage from '$components/cms-image.svelte';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import type { TwoImagesStoryblok } from '$types/bloks';

  export let block: TwoImagesStoryblok;
</script>

<section class="block px-2 py-12 lg:px-8 lg:py-16">
  <div
    class="container isolate mx-auto flex flex-col lg:flex-row gap-2 lg:gap-4"
    use:storyblokEditable={block}
  >
    <CmsImage
      image={block.left}
      class="w-full aspect-2/3 lg:w-[calc(50%-8px)] rounded-sm lg:rounded-md"
    />
    <CmsImage
      image={block.right}
      class="w-full aspect-2/3 lg:w-[calc(50%-8px)] rounded-sm lg:rounded-md"
    />
  </div>
</section>
